import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TranslationLanguageEntity } from './translation-language.entity';

@Index('token-language-unique', ['fkTranslationLanguageId', 'token'], {
	unique: true,
})
@Index('IDX__translation_externalId', ['externalId'])
@Entity('_translation')
export class TranslationEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__translation_language__id',
		nullable: true,
		unsigned: true,
	})
	public fkTranslationLanguageId!: number | null;

	@Column('varchar', { name: '_token', nullable: true, length: 255 })
	public token!: string | null;

	@Column('text', { name: '_translation', nullable: true })
	public translation!: string | null;

	/**
	 * PD-16863 — the `item.externalId` of the item this translation was
	 * imported for. HF's ERP item import writes each item's description as a
	 * token with the ERP's Chinese names as its translations, and stamps every
	 * row it writes with the item's id. A token with any linked live row is
	 * IMPORTED: the editor shows it read-only and the batch save refuses to
	 * change it, because the next import would overwrite the change. NULL for
	 * everything people add themselves.
	 */
	@Column('varchar', { name: 'externalId', nullable: true, length: 255 })
	public externalId!: string | null;

	@ManyToOne(
		() => TranslationLanguageEntity,
		(translationLanguage) => translationLanguage.translations,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__translation_language__id', referencedColumnName: 'id' },
	])
	public fkTranslationLanguage!: TranslationLanguageEntity;
}
